module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-5-688799f34c4111de24a31b9f524ec5b1.jpg";